<template>
  <el-dialog 
    class="dialog-form" 
    append-to-body 
    :visible.sync="visibleManufactory" 
    title="Thêm nhà cung cấp" 
    width="600px" 
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="closePopup"
  >  
    <validation-observer ref="observerSupplier" id="observerSupplier">
      <form>
        <LayoutFieldSet>
          <LayoutField type="block" :required="true">
            <template #label>Tên nhà cung cấp</template>
            <template #input>
              <BaseInput
                placeholder="Nhập tên nhà cung cấp"
                name="Tên nhà cung cấp"
                :rules="'required|lBetween:1,255|CHECK_HTML'"
                v-model="manufacoryAddInfo.name"
              />
            </template>
          </LayoutField>
        </LayoutFieldSet>

        <LayoutFieldSet>
          <LayoutField type="block" :required="true">
            <template #label>Số điện thoại</template>
            <template #input>
              <BaseInput
                placeholder="Nhập số điện thoại"
                name="Số điện thoại"
                :rules="'required|PHONE_NO_3|lBetween:1,15'"
                v-model="manufacoryAddInfo.phoneNo"
                type="phone"
              />
            </template>
          </LayoutField>
        </LayoutFieldSet>

        <LayoutFieldSet type="block">
          <LayoutField type="block">
            <template #label>Thuộc nhóm</template>
            <template #input>
              <el-select v-model="manufacoryAddInfo.groups" placeholder="Lựa chọn nhóm" filterable class="width">
                <el-option v-for="(group, index) in groups" :key="index" :label="group.name" :value="group.value" />
              </el-select>
            </template>
          </LayoutField>

          <LayoutField type="block">
            <template #label>Phân loại</template>
            <template #input>
              <el-select v-model="manufacoryAddInfo.person" placeholder="Lựa chọn phân loại" filterable class="width">
                <el-option v-for="(type, index) in persons" :key="index" :label="type.label" :value="type.value" />
              </el-select>
            </template>
          </LayoutField>
        </LayoutFieldSet>

        <LayoutFieldSet>
          <LayoutField type="block" >
            <template #label>Email</template>
            <template #input>
              <BaseInput
                placeholder="Nhập email"
                name="Email"
                :rules="'EMAIL|CHECK_HTML|lBetween:6,255'"
                v-model="manufacoryAddInfo.email"
              />
            </template>
          </LayoutField>
        </LayoutFieldSet>

        <LayoutFieldSet>
          <LayoutField type="block">
            <template #label>Địa chỉ</template>
            <template #input>
              <BaseTextarea
                placeholder="Nhập địa chỉ"
                name="Địa chỉ cụ thể"
                :rules="'lBetween:3,255|CHECK_HTML'"
                v-model="manufacoryAddInfo.address"
                :value="manufacoryAddInfo.address"
                @value="manufacoryAddInfo.address = $event"
              />
            </template>
          </LayoutField>
        </LayoutFieldSet>
      </form>
    </validation-observer>

    <template slot="footer">
      <el-button 
        type="text"
        @click="closePopup()"
      >
        Thoát
      </el-button>
      <el-button 
        :loading="btnLoading" 
        type="primary" 
        @click="btnConfirmAddSupplier()"
      >
        Hoàn tất
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { getMerchanIDCurrent } from '@/utils/auth'

import { SupplierServices } from "@/services/nextshop/supplier.service"

export default {
  props: {
    isPopup: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      manufacorys: [],
      btnLoading: false,
      visibleManufactory: false,
      groups: [],
      persons: [
        { value: true, label: "Cá nhân" },
        { value: false, label: "Doanh nghiệp" },
      ],
      manufacoryAddInfo: {
        name: '',
        phoneNo: '',
        groups: '',
        person: false,
        email: '',
        address: ''
      },
    }
  },

  created() {
    this.getGroupSupp()
  },

  methods: {
    async btnConfirmAddSupplier() {
      try {
        await this.$refs.observerSupplier.validate();
        let el = document.querySelector("#observerSupplier .is-invalid");
        if (el) {
          el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          el.focus();
        } else {
          this.btnLoading = true
          const req = {
            ...this.manufacoryAddInfo,
            groups: this.manufacoryAddInfo.groups != '' 
              ? [this.manufacoryAddInfo.groups] : [],
            merchantId: getMerchanIDCurrent(),
            avatarUrl: '',
            address: this.manufacoryAddInfo.address != '' 
              ? this.manufacoryAddInfo.address
              : null,
            email: this.manufacoryAddInfo.email != ''
              ? this.manufacoryAddInfo.email
              : null,
          }
          await SupplierServices.createrSupplier(req).then(res => {
            if (res.success && res.code != 'PHONE_EXISTED') {
              this.btnLoading = false
              this.manufacoryAddInfo = {
                name: '',
                phoneNo: '',
                groups: [],
                person: '',
                email: '',
                address: ''
              }
              this.getSuppliers()
            } else {
              this.$message.warning('Số điện thoại đã tồn tại! Vui lòng nhập số điện thoại khác')
              this.manufacoryAddInfo.phoneNo = ''
              this.$refs.observerSupplier.validate();
              this.btnLoading = false
            }
          })
        }
      } catch (error) {
        console.log(error);
        this.$message.error(error)
        this.btnLoading = false
      }
    },

    async getGroupSupp() {
      await SupplierServices.getGroupSupplier({
        merchantId: getMerchanIDCurrent()
      }).then(res => {
        if (res.success) {
          this.groups = res.data.map(gr => {
            return {
              ...gr,
              value: gr.id
            }
          })
          const idGroupTmp = this.groups.find(e => e.name === "Mặc Định")
          this.manufacoryAddInfo.groups = idGroupTmp.value
        }
      })
    },

    async getSuppliers() {
      try {
        const req = {
          merchantId: getMerchanIDCurrent(),
          person: 2,
          query: '',
          sort: 'date'
        }
        await SupplierServices.getListSupplier(req).then(res => {
          if (res.success) {
            const manufacorys = res.data.map(manu => {
              return {
                ...manu,
                value: manu.id
              }
            })
            this.$message.success('Thêm nhà cung cấp thành công')
            this.btnLoading = false
            this.$emit('getValue', manufacorys)
            this.visibleManufactory = false
          }
        })
      } catch (error) {
        console.log(error);
      }
    },

    closePopup() {
      this.visibleManufactory = false
      this.$emit('getValue', null)
    }
  },

  watch: {
    isPopup: {
      handler: function () {
        this.visibleManufactory = this.isPopup
      }
    }
  }
}
</script>

<style>

</style>